<template>
  <div class="common-table-container">
    <el-table
      :data="tableData"
      border
      :show-summary="sumIndex.length>0"
      :summary-method="getSummaries"
      style="width: 100%">
      <template v-for="(item, index) in tableConfig">
        <el-table-column
          align="center"
          v-if="item.formatter"
          :fixed="item.fixed?item.fixed: false"
          :key="`${item.prop}-${index}`"
          :prop="item.prop"
          :label="item.label"
        >
          <template slot-scope="{ row }">
            <div>{{item.formatter(row[item.prop])}}</div>
          </template>
        </el-table-column>
        <el-table-column
          v-else
          align="center"
          :fixed="item.fixed?item.fixed: false"
          :key="`${item.prop}-${index}`"
          :prop="item.prop"
          :label="item.label"
        >
        </el-table-column>
      </template>
      <el-table-column
        fixed="right"
        label="操作"
        align="center"
        width="100">
        <template slot-scope="scope">
          <el-button
            @click="handleClick(scope.row)"
            type="text"
            size="small"
          >详情</el-button>
          <el-button
            v-if="edit"
            @click="handleEdit(scope.row)"
            type="text"
            size="small"
          >编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  name: 'FundCommonTable',
  data() {
    return {

    }
  },
  props: {
    sumIndex: {
      type: Array,
      default: () => {
        return []
      }
    },
    edit: {
      type: Boolean,
      default: false
    },    
    tableData: {
      type: Array,
      required: true
    },
    tableConfig: {
      type: Array,
      required: true
    }
  },
  mounted() {

  },
  methods: {
    getSummaries(param) {
      let {columns, data} = param
      const sums = [];
      if (columns.length > 0) {
        columns.forEach((column, index) => {
          if (this.sumIndex.includes(index)) {
            let values = 0;
            data.map((item) => (values += Number(item[column.property])));
            sums[index] = this.getMoney(values.toFixed(2));            
          } else {
            sums[index] = "-";
          }
        });
      }
      sums[0] = '合计'
      return sums;      
    },
    handleClick(data) {
      this.$emit("handleDetail", data)
    },
    
    handleEdit(data) {
      this.$emit("handleEdit", data)
    }
  }
}
</script>
<style lang="scss" scoped>
/deep/.el-table {
  // border-top: none;
  // border: none;
  // border-right: none;
  border-color: #e0eeff;
  border-bottom: 1px solid #e0eeff;
  display: flex !important;
  flex-direction: column !important;  
}
/deep/.el-table::before {
  background-color: #e0eeff !important;
  height: 0;
}
/deep/ .el-table th, .el-table tr{
  background-color: #f6faff !important;
  border-color: #e0eeff !important;
}
/deep/.el-table--border td, .el-table--border th, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed {
  border-color: #e0eeff !important;
}

//  order默认值为0，只需将表体order置为1即可移到最后，这样合计行就上移到表体上方 
/deep/.el-table__body-wrapper {
  order: 1 !important;
}

/deep/.el-table__fixed-footer-wrapper{
  top: 96px !important;
  z-index: 0;
}

/deep/.el-table__fixed-body-wrapper{
  top: 96px !important
}
</style>